import { Menu, type MenuMultiSelectGroupProps, Text } from "@overmap-ai/blocks"
import { memo } from "react"

import { PROCEDURE_STEP_COMPLETION_STATUSES } from "../../constants"
import { ProcedureStepCompletionStatus } from "../../enums/procedures"
import { procedureStepCompletionStatusData } from "../../mappings/procedures"
import { ProcedureStepCompletionStatusIcon } from "../Icons/ProcedureStepCompletionStatusIcon"
import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

export interface ProcedureStepCompletionStatusMultiSelectGroupProps extends MenuMultiSelectGroupProps<ProcedureStepCompletionStatus> {
	statuses?: ProcedureStepCompletionStatus[]
}

export const ProcedureStepCompletionStatusMultiSelectGroup = memo<ProcedureStepCompletionStatusMultiSelectGroupProps>(
	(props) => {
		const { ref, statuses = PROCEDURE_STEP_COMPLETION_STATUSES, ...rest } = props

		return (
			<Menu.MultiSelectGroup<ProcedureStepCompletionStatus> ref={ref} {...rest}>
				<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
				{statuses.map((status) => {
					const { label } = procedureStepCompletionStatusData[status]

					return (
						<MultiSelectItemTemplate<ProcedureStepCompletionStatus> key={status} value={status}>
							<ProcedureStepCompletionStatusIcon status={status} />
							<Text className="truncate">{label}</Text>
						</MultiSelectItemTemplate>
					)
				})}
			</Menu.MultiSelectGroup>
		)
	},
)
ProcedureStepCompletionStatusMultiSelectGroup.displayName = "ProcedureStepCompletionStatusMultiSelectGroup"
